module.exports = __webpack_public_path__ + "img/footer-bg-image.827de01.png";